module.exports = __webpack_public_path__ + "img/menu-tongzhi.553aeeb5.svg";